package com.vizio.redwolf.pay.model

data class RewardsRequestInfo(
    val pageNumber: Int? = null,
    val pageSize: Int? = null,
    val accessToken: String
)